var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 173,
    viewBox: "0 0 354 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05936,
    y: 0.5,
    width: 352.11,
    height: 172,
    rx: 11.5,
    fill: "#EBEBEB",
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.614 55.7631C121.269 60.1077 121.269 67.1002 121.269 81.0852V95.9185C121.269 109.903 121.269 116.896 125.614 121.241C129.958 125.585 136.951 125.585 150.936 125.585H172.683C186.668 125.585 193.661 125.585 198.005 121.241C202.35 116.896 202.35 109.903 202.35 95.9185V81.0852C202.35 70.2384 202.35 63.5981 200.323 59.137V107.043C200.008 107.043 199.85 107.043 199.697 107.04C196.203 106.968 192.846 105.665 190.218 103.359C190.104 103.259 189.988 103.153 189.758 102.942L189.755 102.939L189.755 102.939L186.795 100.232C183.243 96.9824 181.467 95.3578 179.382 94.97C178.485 94.8033 177.566 94.8033 176.67 94.97C174.585 95.3578 172.809 96.9824 169.256 100.232L169.256 100.232L168.724 100.719C165.82 103.375 164.368 104.703 162.795 104.604C162.466 104.584 162.142 104.519 161.831 104.413C160.339 103.904 159.495 102.104 157.808 98.5027C154.286 90.9858 152.525 87.2274 149.364 86.2683C148.897 86.1266 148.417 86.0313 147.931 85.9839C144.643 85.6633 141.61 88.4368 135.546 93.9839L127.35 101.481V54.3457C126.726 54.7575 126.15 55.2273 125.614 55.7631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.977 81.0832C124.977 73.9858 124.985 69.0359 125.487 65.3011C125.975 61.673 126.867 59.7517 128.236 58.3833C129.604 57.0148 131.526 56.1226 135.154 55.6348C138.888 55.1327 143.838 55.1248 150.936 55.1248H172.683C179.78 55.1248 184.73 55.1327 188.465 55.6348C192.093 56.1226 194.014 57.0148 195.383 58.3833C196.751 59.7517 197.643 61.673 198.131 65.3011C198.633 69.0359 198.641 73.9858 198.641 81.0832V95.9165C198.641 103.014 198.633 107.964 198.131 111.699C197.643 115.327 196.751 117.248 195.383 118.616C194.014 119.985 192.093 120.877 188.465 121.365C184.73 121.867 179.78 121.875 172.683 121.875H150.936C143.838 121.875 138.888 121.867 135.154 121.365C131.526 120.877 129.604 119.985 128.236 118.616C126.867 117.248 125.975 115.327 125.487 111.699C124.985 107.964 124.977 103.014 124.977 95.9165V81.0832Z",
    stroke: "white",
    strokeWidth: 7.41667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.e734e10bb83891d5000c28fb619805cc.svg";
export { ForwardRef as ReactComponent };